let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("04G5Q")).then(() => parcelRequire('U4Few'));